export default __webpack_public_path__ + "static/designer-lion-hiker@2x-98d375c83defec6e3f6fb8981f5d48d6.png";